export const initialState = {
	lokasi: {
		body: [],
		count: 1,
		sisa: true,
		limit: 10,
		pages: 1,
	},
	loading: false,
};

export const actions = {
	CHANGE_LOKASI: "CHANGE_LOKASI",
	CHANGE_LOADING: "CHANGE_LOADING",
};
